import * as yup from 'yup';

export interface FormData {
  bicycleCoverage: boolean;
  electronicsCoverage: boolean;
  accidentCoverage: boolean;
  typeOfTravelInsurance: string;
  name: string;
  cprNumber: string;
  cprConsent: boolean;
  phoneNumber: string;
  email: string;
  address: string;
  zipCode: string;
  city: string;
  caMember: string;
  registrationNumber: string;
  accountNumber: string;
  purchaseConditionsConsent: boolean;
  hasInsuranceWithOthers: string;
  householdInsuranceDetails: string;
  accidentInsuranceDetails: string;
  travelInsuranceDetails: string;
  terminationValidFrom: string;
}

yup.setLocale({
  mixed: {
    required: 'Dette felt er obligatorisk'
  }
});

export const validationSchema = (formData: FormData) => {
  return yup.object().shape({
    bicycleCoverage: yup.bool(),
    electronicsCoverage: yup.bool(),
    accidentCoverage: yup.bool(),
    typeOfTravelInsurance: yup.string(),
    name: yup.string().required(),
    cprNumber: yup.string().required(),
    cprConsent: yup.bool().oneOf([true], 'Du skal give samtykke'),
    phoneNumber: yup.string().required(),
    email: yup
      .string()
      .required()
      .email(`${formData.email} er ikke en gyldig email`),
    address: yup.string().required(),
    zipCode: yup.string().required(),
    city: yup.string().required(),
    caMember: yup.string().required(),
    registrationNumber: yup.string().required(),
    accountNumber: yup.string().required(),
    purchaseConditionsConsent: yup
      .bool()
      .oneOf([true], 'Du skal give samtykke'),
    hasInsuranceWithOthers: yup.string().required(),
    householdInsuranceDetails: yup.string(),
    accidentInsuranceDetails: yup.string(),
    travelInsuranceDetails: yup.string(),
    terminationValidFrom:
      formData.hasInsuranceWithOthers === 'Ja'
        ? yup.string().required()
        : yup.string()
  });
};

export const to = (_body: any) => {
  return 'castudie@gjensidige.dk';
};

export const receipt = (body: any) => {
  return {
    subject: 'Tillykke med din nye CA Studieforsikring',
    message: `<div>
    <p>Hej
    <br/><br/>
    Du har nu gennemført købet af din nye forsikring. Vi sender dig snart dine forsikringspapirer på e-Boks.
    Hvis du har spørgsmål til din forsikring, er vi klar til at hjælpe dig på 70 10 90 09.
    <br/><br/>
    Med venlig hilsen<br/>
    Gjensidige</p>
    </div>`
  };
};

export default validationSchema;
